import { JournalState } from './journal.state';
import { Action, createReducer, on } from '@ngrx/store';
import { journalInitialize, journalUpdate } from './journal.actions';
import { upsertIf } from '../../utils/array-reducer';
import { ActionStatusEnum } from '../../enum/action-status.enum';

const initialState: JournalState = {
    entries: []
};

const reducer = createReducer(
    initialState,
    on(journalInitialize, (state, { entries }) => (
        { entries: [ ...entries ] }
    )),
    on(journalUpdate, (state, { action }) => ({
        entries: upsertIf(state.entries, action, 'channel', (oldAction, newAction) => {
            if (newAction.status === ActionStatusEnum.COMPLETED) {
                return true;
            }
            if (newAction.status === ActionStatusEnum.ERROR) {
                return true;
            }
            if (oldAction.status === ActionStatusEnum.COMPLETED) {
                return false;
            }
            if (oldAction.status === ActionStatusEnum.ERROR) {
                return false;
            }
            if (newAction.status === ActionStatusEnum.PROCESSING) {
                return (oldAction.status === ActionStatusEnum.PENDING || oldAction.status === ActionStatusEnum.PROCESSING)
                    && newAction.progress > oldAction.progress;
            }
            if (newAction.status === ActionStatusEnum.PENDING) {
                return false;
            }
            return true;
        })
    }))
);

export function journalReducer(state: JournalState | undefined, action: Action): any {
    return reducer(state, action);
}
